import axios from "axios"

const brandId = 2 // ford
const host = "https://serviceforms.delek-motors.co.il/Home"

export interface RecallData {
  brandId: number
  chassisNumber: string
  description: string
  id: number
  licenseNumber: string
  numberCol: number
  reportingDate: string
  shortName: string
}

export interface ReplacementsData {
  id: number
  brandId: number
  foreignName: string
  isOriginal: string
  isWithQuantity: string
  item: string
  modelDescription: string
  name: string
  priceWithTax: number
  provider: string
  sku: string
  vehicleModel: string
}

export interface WarrantyBaseData {
  component: string
  extensionDuration: string
  id: number
  phenomenonDesc: string
}

export interface WarrantyData extends WarrantyBaseData {
  brandId: number
  chassisNumber: string
  description: string
  licenseNumber: string
}

export interface DelekResponse<T> {
  error: string | null
  data: T[]
  result: boolean
}

export type DelekRecallsResponse = DelekResponse<RecallData>
export const getRecalls = (data: string) => {
  const param = data.length < 14 ? `licenseNumber` : `chassis`
  const uri = `${host}/GetRecalls?brandId=${brandId}&${param}=${data}`
  return axios.get<DelekRecallsResponse>(uri)
}

export type DelekWarrantyExtensionsBaseResponse = DelekResponse<WarrantyBaseData>
export const GetWarrantyExtensionsTopTable = () => {
  const uri = `${host}/GetWarrantyExtensionsTopTable?brandId=${brandId}`
  return axios.get<DelekWarrantyExtensionsBaseResponse>(uri)
}

export type DelekWarrantyExtensionsResponse = DelekResponse<WarrantyData>
export const GetWarrantyExtensions = (data: string) => {
  const param = data.length < 14 ? `licenseNumber` : `chassis`
  const uri = `${host}/GetWarrantyExtensions?brandId=${brandId}&${param}=${data}`
  return axios.get<DelekWarrantyExtensionsResponse>(uri)
}

export type DelekReplacementsResponse = DelekResponse<ReplacementsData>
export const GetPriceListReplacements = (data: string) => {
  data = data.trim()
  const param = /^[A-Z]{0,2}\d+$/.test(data) ? `sku` : `name`
  const uri = `${host}/GetPriceListReplacements?brandId=${brandId}&${param}=${data}`
  return axios.get<DelekReplacementsResponse>(uri)
}
